import { j as b } from "../../_virtual/jsx-runtime.js";
import { c as O } from "../../_virtual/compiler-runtime.js";
import { cn as N } from "../../utils/cn.js";
import { tv as M } from "../../bundled_deps/.pnpm/tailwind-variants@0.3.1_tailwindcss@3.4.17/bundled_deps/tailwind-variants/dist/index.js";
const V = M({
  base: "relative rounded-full border text-default border-neutral-border",
  variants: {
    type: {
      default: "bg-neutral-container",
      action: "bg-success-container border-success-border",
      invalid: "bg-error-container border-error-border"
    },
    isMultiline: {
      true: "py-1.5 pe-8 ps-3",
      false: "inline-block py-1.5 px-3"
    },
    isOpen: {
      true: "",
      false: ""
    },
    isClickable: {
      true: "cursor-pointer",
      false: ""
    }
  },
  compoundVariants: [
    // hover states
    {
      type: "default",
      isClickable: !0,
      class: "hover:bg-neutral-container-emphasis hover:border-neutral-border-emphasis"
    },
    {
      type: "action",
      isClickable: !0,
      class: "hover:bg-success-container-emphasis hover:border-success-border active:border-success-border-emphasis"
    },
    {
      type: "invalid",
      isClickable: !0,
      class: "hover:bg-error-container-emphasis hover:border-error-border active:border-error-border-emphasis"
    },
    // open states
    {
      isOpen: !0,
      type: "default",
      class: "bg-neutral-container-emphasis border-neutral-border-emphasis"
    },
    {
      isOpen: !0,
      type: "action",
      class: "bg-success-container-emphasis border-success-border-emphasis"
    },
    {
      isOpen: !0,
      type: "invalid",
      class: "bg-error-container-emphasis border-error-border-emphasis"
    }
  ],
  defaultVariants: {
    type: "default"
  }
});
function T(C) {
  const e = O.c(23), {
    details: c,
    icon: d,
    name: u,
    className: m,
    isInvalid: h,
    isMultiline: y,
    isOpen: k,
    isClickable: x,
    type: g,
    onClick: f
  } = C, j = h === void 0 ? !1 : h, s = y === void 0 ? !1 : y, r = k === void 0 ? !1 : k, v = x === void 0 ? !1 : x, i = j ? "invalid" : g === void 0 ? "default" : g;
  let t;
  e[0] !== m || e[1] !== i || e[2] !== v || e[3] !== s || e[4] !== r ? (t = N(V({
    isMultiline: s,
    isOpen: r,
    isClickable: v,
    type: i
  }), m), e[0] = m, e[1] = i, e[2] = v, e[3] = s, e[4] = r, e[5] = t) : t = e[5];
  let a;
  e[6] !== f ? (a = () => f?.(), e[6] = f, e[7] = a) : a = e[7];
  let o;
  e[8] !== d ? (o = d && /* @__PURE__ */ b.jsx("span", { className: "inline-block relative -top-px", children: d }), e[8] = d, e[9] = o) : o = e[9];
  let l;
  e[10] !== u || e[11] !== o ? (l = /* @__PURE__ */ b.jsxs("span", { className: "font-medium", children: [
    o,
    " ",
    u
  ] }), e[10] = u, e[11] = o, e[12] = l) : l = e[12];
  let n;
  e[13] !== c || e[14] !== s ? (n = c && /* @__PURE__ */ b.jsxs("p", { className: s ? "block" : "inline", children: [
    " ",
    c
  ] }), e[13] = c, e[14] = s, e[15] = n) : n = e[15];
  let p;
  return e[16] !== i || e[17] !== r || e[18] !== n || e[19] !== t || e[20] !== a || e[21] !== l ? (p = /* @__PURE__ */ b.jsxs("div", { "data-testid": "filter-block", "data-type": i, "data-open": r, className: t, onClick: a, children: [
    l,
    n
  ] }), e[16] = i, e[17] = r, e[18] = n, e[19] = t, e[20] = a, e[21] = l, e[22] = p) : p = e[22], p;
}
export {
  T as FilterBlock
};
